import { PageType } from '../enums/PageType';

export enum Language {
  ENGLISH = 'English',
  TELUGU = 'Telugu',
  TAMIL = 'Tamil',
}

export enum BaseSubscription {
  NO_SUBSCRIPTION = 'No Subscription',
}

export enum UserType {
  REGISTERED = 'Registered',
  SUBSCRIBED = 'Subscribed',
  ANONYMOUS = 'Anonymous',
}

export interface NRPlaybackStatistics {
  contentDurationSec?: number;
  playbackStartedTimeSec?: number;
  displayedFrameRate?: number;
  droppedDecodedFrameCount?: number;
  droppedDisplayedFrameCount?: number;
  videoResolution?: string;
  currentBandwidthKb?: number;
  observedBandwidth?: number;
  estimatedBandwidth?: number;
  videoBitrate?: number;
  highestVariantBandwidthKb?: number;
  lowestVariantBandwidthKb?: number;
  lastPlayedVariant?: number;
  lastAttemptedVariant?: number;
  playbackDurationSec?: number;
  searchItemPosition?: string;
  playerLoadLatency?: number;
}

export interface PlaybackDrmInfo {
  drmName: string;
  drmVersion?: string;
}

export interface SubtitleInfo {
  audioLanguage: string;
  subtitleLanguage?: string;
  ccEnabled: boolean;
}

export interface PlayerInfo {
  playerName: string;
}

export interface PageInfo {
  pageID: PageType;
  tabID: string;
}

export interface PlaybackInfo {
  playbackURL: string;
  streamId: string;
}
export interface VODInfo {
  vod: string;
  vod_type: string;
}

export interface CollectionInfo {
  collectionID: string;
  collectionName: string;
}

export interface TabInfo {
  tabID: string;
  tabName: string;
}

export interface ContainerInfo {
  containerID: string;
  containerName: string;
}

export interface ChannelInfo {
  channelID: string;
  channelName: string;
}
export interface ContentInfo {
  storefrontID: string;
  providerID: string;
  contentKey: string;
  contentID: string;
  contentType: string;
  contentGenre: string;
  contentName: string;
  episodeNumber: string;
  seasonNumber: string;
  seriesName: string;
  isFreePreview: boolean;
}

export enum BrowserName {
  edge = 'edge',
  opera = 'opera',
  chrome = 'chrome',
  ie = 'ie',
  safari = 'safari',
  firefox = 'firefox',
  others = 'others',
}

export enum UserAgentOs {
  Windows = 'Windows',
  MacOS = 'MacOS',
  Unix = 'Unix',
  Linux = 'Linux',
  Android = 'Android',
}

export interface UserRegionInfo {
  city: string;
  userCity: string;
  countryCode: string;
  regionCode: string;
}

export interface UserInfo {
  accountId?: number;
  userID: string;
  userType: UserType;
  userCategory: string;
  profileID: string;
  baseSubscription: string;
  silentLogin: boolean;
}

export interface TimeInfo {
  timeToAppConfig: number;
  timeToLoadStorefront: number;
  timeToSplash: number;
  appStartUpTime: number;
}

export interface DeviceInfo {
  device: string;
  deviceID: string;
  deviceGroup: string;
  deviceManufacturer: string;
  deviceModel: string;
  deviceType: string;
  deviceName: string;
}

export interface EventInfo {
  appName: string;
  eventTimestamp: number;
  session?: string;
  // timeSinceLoad: number;
}

export interface BrowserInfo {
  userAgentName: string;
  userAgentOS: string;
  userAgentVersion: string;
}

export interface LanguageInfo {
  contentLanguage: string;
  displayLanguage?: Language;
  preferredLanguage: string;
}
export interface AppInfo {
  appVersion: string;
  appBuild: string;
}

export interface AsnInfo {
  asn: string;
  asnOwner: string;
}
